// IDs dos vídeos de depoimentos do YouTube

export const TESTIMONIAL_VIDEOS = [
  {
    id: 1,
    videoId: 'JF1kbSxDpR0',
    name: 'Antoniela',
    caption: 'Paciente há 10 anos',
  },
  {
    id: 2,
    videoId: 'FWFKWsIfWRI',
    name: 'Ruth',
    caption: 'Paciente há 9 anos - Pós-Bariátrica',
  },
  {
    id: 3,
    videoId: 'GG5RQnMSfAk',
    name: 'Geliane',
    caption: 'Pós-Bariátrica',
  },
  {
    id: 4,
    videoId: 'aeWwQMYecYE',
    name: 'Denisse',
    caption: 'Paciente atual',
  },
] as const;
